export enum SearchLocationType {
  COUNTRY = 'COUNTRY',
  CITY = 'CITY',
  REGION = 'REGION',
  HARBOR = 'HARBOR',
}
